// Which step controls are live while the board's Controls constraint holds
// them to a range (a puzzle): the steps look back along the path the board
// has travelled, down to the range's start, and forward again up to its end,
// never past the board's own position. Looking is a view (`review.browse`),
// not a move; the session does the looking, this only says what is enabled.
import { headPly, viewPly, type ReviewState } from '@chess/api-review';

export interface RangedSteps {
  canBack: boolean;
  canForward: boolean;
}

export function rangedSteps(state: ReviewState, range: { from: number; to: number } | undefined): RangedSteps {
  const ready = state.status === 'ready' && !!state.game;
  if (!range) return { canBack: false, canForward: false };
  const view = viewPly(state);
  const end = Math.min(range.to, headPly(state));
  return { canBack: ready && view > range.from, canForward: ready && view < end };
}
